// extracted by mini-css-extract-plugin
export default {"container":"Container_container__w8Nlx","containerBox":"Container_containerBox__Bzj11"};